import { render, staticRenderFns } from "./SwipeCartFromBottom.vue?vue&type=template&id=74f2e07a&"
import script from "./SwipeCartFromBottom.vue?vue&type=script&lang=js&"
export * from "./SwipeCartFromBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports